// extracted by mini-css-extract-plugin
module.exports = {"bar":"progress-bar_bar__zsJed","bar_value":"progress-bar_bar_value__MYChZ","barText":"progress-bar_barText__qpdtD"};